// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer___2vT-1","footer__twitter":"footer__footer__twitter___-DbBX","footer__icon":"footer__footer__icon___2DCov"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Footer/footer.scss
// module id = 122
// module chunks = 0